import React from 'react';
import { CardContainer, VerticalContainer } from './Containers';
import { BoldText, SmallText } from './Texts';
import designSystemStyles from '@shared/styles/designSystemStyles';
import styles from '@shared/styles/components/StatCard.module.css';

export interface StatCardProps {
    label: string;
    count: number;
    color?: string;
    selected?: boolean;
    loading?: boolean;
    onClick?: () => void;
    width?: string;
    className?: string;
}

const StatCard: React.FC<StatCardProps> = ({
    label,
    count,
    color = designSystemStyles.colorMainAction,
    selected = false,
    loading = false,
    onClick,
    width = '150px',
    className,
}) => {
    const content = (
        <CardContainer width={width} padding={designSystemStyles.paddingMd}>
            <VerticalContainer gap="2px" justifyContent="center">
                {loading ? (
                    <>
                        <span className={[styles.skeletonLine, styles.skeletonCount].join(' ')} />
                        <span className={[styles.skeletonLine, styles.skeletonLabel].join(' ')} />
                    </>
                ) : (
                    <>
                        <BoldText text={String(count)} color={color} />
                        <SmallText text={label} color={designSystemStyles.colorTextSecondary} />
                    </>
                )}
            </VerticalContainer>
        </CardContainer>
    );

    if (onClick == null || loading) {
        return (
            <div
                aria-busy={loading || undefined}
                className={[styles.statCard, loading ? styles.loading : '', selected && !loading ? styles.selected : '', className].filter(Boolean).join(' ')}
                style={{
                    '--stat-card-color': color,
                } as React.CSSProperties}
            >
                {content}
            </div>
        );
    }

    return (
        <button
            type="button"
            aria-pressed={selected}
            className={[styles.statCard, styles.clickable, selected ? styles.selected : '', className].filter(Boolean).join(' ')}
            style={{
                '--stat-card-color': color,
            } as React.CSSProperties}
            onClick={onClick}
        >
            {content}
        </button>
    );
};

export default StatCard;
